import { observer } from 'mobx-react'
import { useEffect } from 'react'
import ContentState from '../../../../stores/ContentState'
import './index.scss'

const ServicesList2 = observer(() => {
  const content = ContentState.services?.services2

  useEffect(() => {
    const list = document.querySelector('.services-list2')
    if (!list) return
    const top = list?.getBoundingClientRect().top,
      body = document.body.getBoundingClientRect().top

    const offset = top - body

    window.addEventListener('scroll', () => {
      if (window.scrollY > offset) {
        document.querySelector('.things-menu')?.classList.add('services-block')
      } else
        document
          .querySelector('.things-menu')
          ?.classList.remove('services-block')
    })
  }, [])

  if (!content) return <></>

  return (
    <section className="services-list2">
      <div className="services-list2__title">{content.title}</div>
      <div className="services-list2__list">
        {content?.list?.map((l: any, i: number) => (
          <div className="services-list2__item" key={i}>
            <div
              className="services-list2__item-row"
              style={
                !l.text?.length
                  ? {
                      marginBottom: 0,
                    }
                  : {}
              }
            >
              <div className="services-list2__item-img">
                <img src={l.img} />
              </div>
              <div className="services-list2__item-title">{l.title}</div>
            </div>
            {l.text.length ? (
              <div
                className="services-list2__item-text"
                dangerouslySetInnerHTML={{ __html: l.text }}
              ></div>
            ) : (
              <></>
            )}
          </div>
        ))}
      </div>
      <div className="services-list2__digit">
        <div className="services-list2__digit-title">
          {ContentState.services.digit}
        </div>
        <div className="services-list2__list">
          {ContentState.services?.digitList?.map((l: any, i: number) => (
            <div className="services-list2__item" key={i}>
              <div
                className="services-list2__item-row"
                style={
                  !l.text?.length
                    ? {
                        marginBottom: 0,
                      }
                    : {}
                }
              >
                <div className="services-list2__item-img">
                  <img src={l.img} />
                </div>
                <div className="services-list2__item-title">{l.title}</div>
              </div>
              {l.text.length ? (
                <div
                  className="services-list2__item-text"
                  dangerouslySetInnerHTML={{ __html: l.text }}
                ></div>
              ) : (
                <></>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  )
})

export default ServicesList2
